var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("PaginationController", {
        attrs: {
          getDataActionName: "getLabelPagination",
          historyLimit: _vm.historyLimit,
          haveSearchBox: true,
          select: (_vm.selectedBalanceTable || {}).clientKey,
          showSearchBoxLabel: false,
          actionPredicates: _vm.generatePredicate(),
          isStartWithoutData: true
        },
        scopedSlots: _vm._u([
          {
            key: "dataTable",
            fn: function() {
              return [
                _c("v-data-table", {
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.labels,
                    "hide-actions": "",
                    search: _vm.filterText,
                    "item-key": "orderId"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(props) {
                        return [
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(props.index + 1) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              _c("LabelDetailsWidget", {
                                attrs: {
                                  shipmentLabel: props.item,
                                  index: props.index
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              _c("LabelAddressWidget", {
                                attrs: { address: props.item.from }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              _c("LabelAddressWidget", {
                                attrs: { address: props.item.to }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.$store.getters.activeWarehouse
                            ? _c("td", { staticClass: "text-xs-left" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.organizationKeyToId.get(
                                        props.item.clientKey
                                      )
                                    ) +
                                    "\n          "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              _c("v-layout", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.toDateYYYYMMDDHHmm(
                                        props.item.createTime
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("v-layout", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(props.item.shipDate) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              props.item.estimatedDelivery &&
                              props.item.estimatedDelivery !== "N/A"
                                ? _c(
                                    "v-layout",
                                    { staticClass: "text-capitalize" },
                                    [
                                      typeof props.item.estimatedDelivery ===
                                      "string"
                                        ? _c("v-flex", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.toDateYYYYMMDDHHmm(
                                                  new Date(
                                                    props.item.estimatedDelivery
                                                  )
                                                )
                                              )
                                            )
                                          ])
                                        : _c("v-flex", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.toDateYYYYMMDDHHmm(
                                                  props.item.estimatedDelivery
                                                )
                                              )
                                            )
                                          ])
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              props.item.status !== "failed"
                                ? [
                                    props.item.status !== "failed"
                                      ? _c("LabelTrackingDetailWidget", {
                                          attrs: {
                                            trackingNumber:
                                              props.item.trackingNumber,
                                            status: props.item.status,
                                            carrier: props.item.carrier,
                                            details: props.item.trackingDetails
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    [
                                      "ready",
                                      "in transit",
                                      "delivered"
                                    ].includes(props.item.status) &&
                                    !!props.item.trackStatus
                                      ? _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              props.item.trackStatus.toLowerCase()
                                            )
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                : _c(
                                    "div",
                                    _vm._l(props.item.messages, function(
                                      messageItem
                                    ) {
                                      return _c(
                                        "p",
                                        { key: messageItem.time },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(messageItem.message) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(_vm._s(props.item.serviceDescription))
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              class: props.item.totalAmount
                                ? "text-xs-left fontRed"
                                : props.item.amount > 0
                                ? "text-xs-left fontGreen"
                                : "text-xs-left fontRed"
                            },
                            [
                              _vm._v(
                                "\n            $" +
                                  _vm._s(
                                    -props.item.totalAmount ||
                                      props.item.amount ||
                                      0
                                  ) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(_vm._s(_vm.getStatusText(props.item)))
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: false,
                                  expression: "false"
                                }
                              ],
                              staticClass: "text-xs-left"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  (props.item.trackingNumbers &&
                                    props.item.trackingNumbers.join(",")) ||
                                    ""
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-center" },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "" } },
                                [
                                  props.item.status === "pending"
                                    ? _c(
                                        "v-flex",
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { top: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function(tooltip) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          _vm._g(
                                                            {},
                                                            tooltip.on
                                                          ),
                                                          [
                                                            _c("LoaderButton", {
                                                              attrs: {
                                                                flat: "",
                                                                buttonIcon:
                                                                  "refresh",
                                                                promiseAwait:
                                                                  _vm.getLabelStatus,
                                                                promiseItem:
                                                                  props.item
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(_vm.$t("getStatus")) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _c(
                                        "v-flex",
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { top: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function(tooltip) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          _vm._g(
                                                            {},
                                                            tooltip.on
                                                          ),
                                                          [
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  dark: "",
                                                                  flat: "",
                                                                  color:
                                                                    "primary",
                                                                  disabled: !props
                                                                    .item.url,
                                                                  icon: ""
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.downloadFile(
                                                                      props.item
                                                                        .url,
                                                                      props.item
                                                                        .orderId
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v(
                                                                    "preview"
                                                                  )
                                                                ])
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(_vm.$t("openLabel")) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                  _vm._v(" "),
                                  props.item.invoiceUrl
                                    ? _c(
                                        "v-flex",
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { top: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function(tooltip) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          _vm._g(
                                                            {},
                                                            tooltip.on
                                                          ),
                                                          [
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  flat: "",
                                                                  icon: "",
                                                                  color:
                                                                    "orange",
                                                                  disabled: [
                                                                    "canceled",
                                                                    "failed"
                                                                  ].includes(
                                                                    props.item
                                                                      .status
                                                                  )
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.downloadFile(
                                                                      props.item
                                                                        .invoiceUrl,
                                                                      props.item
                                                                        .orderKey,
                                                                      props.item
                                                                        ._key
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v(
                                                                    "receipt"
                                                                  )
                                                                ])
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t("downloadInvoice")
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    [
                                      props.item.trackingNumbers &&
                                      props.item.trackingNumbers.length > 1
                                        ? _c(
                                            "v-menu",
                                            {
                                              attrs: { bottom: "", left: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function(ref) {
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            {
                                                              attrs: {
                                                                flat: "",
                                                                small: ""
                                                              }
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _vm._v(
                                                              "\n                    " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "proofDelivery"
                                                                  )
                                                                ) +
                                                                "\n                    "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            },
                                            [
                                              _vm._v(" "),
                                              _c(
                                                "v-list",
                                                { attrs: { dense: "" } },
                                                [
                                                  _c("v-subheader", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("trackingNumber")
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    props.item.trackingNumbers,
                                                    function(trackingNumber) {
                                                      return _c(
                                                        "v-list-tile",
                                                        {
                                                          key: trackingNumber,
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.proofDelivery(
                                                                props.item,
                                                                trackingNumber
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-tile-title",
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  trackingNumber
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                            ],
                                            1
                                          )
                                        : _c(
                                            "v-tooltip",
                                            {
                                              attrs: { top: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function(tooltip) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          _vm._g(
                                                            {},
                                                            tooltip.on
                                                          ),
                                                          [
                                                            _c("LoaderButton", {
                                                              attrs: {
                                                                flat: "",
                                                                buttonText: _vm.$t(
                                                                  "proofDelivery"
                                                                ),
                                                                disabled: !props
                                                                  .item
                                                                  .trackingNumber,
                                                                promiseAwait: function() {
                                                                  return _vm.proofDelivery(
                                                                    props.item
                                                                  )
                                                                },
                                                                promiseItem:
                                                                  props.item
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t("proofDelivery")
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { top: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(tooltip) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      _vm._g({}, tooltip.on),
                                                      [
                                                        ![
                                                          "canceled",
                                                          "failed"
                                                        ].includes(
                                                          props.item.status
                                                        )
                                                          ? _c("LoaderButton", {
                                                              attrs: {
                                                                flat: "",
                                                                promiseAwait:
                                                                  _vm.cancelLabel,
                                                                promiseItem:
                                                                  props.item,
                                                                buttonIcon:
                                                                  "delete"
                                                              }
                                                            })
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.$t("delete")) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                })
              ]
            },
            proxy: true
          },
          {
            key: "beforeMenu",
            fn: function() {
              return [
                _c(
                  "v-layout",
                  { attrs: { "justify-start": "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs4: "", "mr-1": "" } },
                      [
                        _c("v-select", {
                          attrs: {
                            items: [
                              { name: _vm.$t("keyword"), value: "keyword" },
                              {
                                name: _vm.$t("batchByRequestId"),
                                value: "requestIds"
                              },
                              {
                                name: _vm.$t("batchByTracking"),
                                value: "trackings"
                              }
                            ],
                            "item-value": "value",
                            "item-text": "name",
                            label: _vm.$t("searchMode")
                          },
                          on: {
                            change: function(e) {
                              _vm.searchText = ""
                              _vm.requestIds = []
                              _vm.selectStatus = ""
                              _vm.searchTrackings = []
                              _vm.trackStatusValue = ""
                            }
                          },
                          model: {
                            value: _vm.searchMode,
                            callback: function($$v) {
                              _vm.searchMode = $$v
                            },
                            expression: "searchMode"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.searchMode === "trackings"
                      ? _c(
                          "v-flex",
                          { attrs: { xs8: "", "pl-3": "" } },
                          [
                            _c("v-combobox", {
                              attrs: {
                                label: _vm.$t("tracking") + "(max: 10)",
                                "small-chips": "",
                                "deletable-chips": "",
                                "return-object": false,
                                hint:
                                  _vm.$t("trackingNumber") +
                                  " **" +
                                  _vm.$t("enterToNext"),
                                multiple: "",
                                clearable: ""
                              },
                              on: {
                                change: function($event) {
                                  return _vm.changeBatchSearch(
                                    _vm.searchTrackings,
                                    "searchTrackings"
                                  )
                                }
                              },
                              model: {
                                value: _vm.searchTrackings,
                                callback: function($$v) {
                                  _vm.searchTrackings = $$v
                                },
                                expression: "searchTrackings"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.searchMode === "requestIds"
                      ? _c(
                          "v-flex",
                          { attrs: { xs8: "", "pl-3": "" } },
                          [
                            _c("v-combobox", {
                              attrs: {
                                label: _vm.$t("requestId") + "(max: 10)",
                                "small-chips": "",
                                "deletable-chips": "",
                                "return-object": false,
                                hint:
                                  _vm.$t("requestId") +
                                  " **" +
                                  _vm.$t("enterToNext"),
                                multiple: "",
                                clearable: ""
                              },
                              on: {
                                change: function($event) {
                                  return _vm.changeBatchSearch(
                                    _vm.requestIds,
                                    "requestIds"
                                  )
                                }
                              },
                              model: {
                                value: _vm.requestIds,
                                callback: function($$v) {
                                  _vm.requestIds = $$v
                                },
                                expression: "requestIds"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.searchMode === "keyword"
                      ? [
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.labelStatusArray,
                                  "item-value": "value",
                                  "item-text": "name",
                                  label: _vm.$t("labelStatus")
                                },
                                model: {
                                  value: _vm.selectStatus,
                                  callback: function($$v) {
                                    _vm.selectStatus = $$v
                                  },
                                  expression: "selectStatus"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "", "ml-1": "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.trackStatusArray,
                                  "item-value": "value",
                                  "item-text": "name",
                                  label: _vm.$t("trackStatus")
                                },
                                model: {
                                  value: _vm.trackStatusValue,
                                  callback: function($$v) {
                                    _vm.trackStatusValue = $$v
                                  },
                                  expression: "trackStatusValue"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", "ml-3": "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  hint:
                                    _vm.$t("memo") +
                                    "/" +
                                    _vm.$t("recipient") +
                                    "/" +
                                    _vm.$t("serviceType") +
                                    "/" +
                                    _vm.$t("tracking"),
                                  label: _vm.$t("search"),
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.searchText,
                                  callback: function($$v) {
                                    _vm.searchText = $$v
                                  },
                                  expression: "searchText"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("v-flex", { attrs: { xs1: "" } }),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { xs4: "" } },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            label: _vm.$t("selectOrg"),
                            "return-object": "",
                            "item-text": "clientName",
                            items: _vm.balances,
                            clearable: ""
                          },
                          model: {
                            value: _vm.selectedBalanceTable,
                            callback: function($$v) {
                              _vm.selectedBalanceTable = $$v
                            },
                            expression: "selectedBalanceTable"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  2
                )
              ]
            },
            proxy: true
          },
          {
            key: "afterDate",
            fn: function() {
              return [
                _c(
                  "v-flex",
                  { attrs: { xs4: "" } },
                  [
                    _c("v-text-field", {
                      attrs: { label: _vm.$t("filter"), clearable: "" },
                      model: {
                        value: _vm.filterText,
                        callback: function($$v) {
                          _vm.filterText = $$v
                        },
                        expression: "filterText"
                      }
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.labels,
          callback: function($$v) {
            _vm.labels = $$v
          },
          expression: "labels"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d34ddd2a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d34ddd2a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LabelAdmin.vue
// module id = null
// module chunks = 